import classNames from 'classnames'
import IndicesCard from '@/components/Stocks/Indicies/components/IndicesCard'
import { Index } from '@/components/Stocks/Widgets/types'
import InStockL2Heading from '@/components/Stocks/Pages/InStockDetailPageV2/InL2Heading'

const IndicesInclusion = ({
  linked_indexes,
  heading = '',
}: {
  linked_indexes?: Index[]
  heading?: string
}) => {
  if (!linked_indexes?.length) return null
  return (
    <div>
      <InStockL2Heading
        heading={`Indices Featuring ${heading} Stock`}
        subheading={`Check stock indices that include ${heading}.`}
      />
      <div
        className={classNames(
          'no-scrollbar mt-4 flex flex-row flex-nowrap items-start gap-2 overflow-auto overflow-x-scroll lg:gap-4',
        )}
      >
        {linked_indexes.map((item, idx) => (
          <IndicesCard
            indexData={{
              ...item,
              oneD_change: item.day_change,
              absolute_change: item.day_change_percentage,
              relative_path: item.path,
            }}
            key={`indicies${idx}`}
          />
        ))}
      </div>
    </div>
  )
}

export default IndicesInclusion
